import React from 'react';

import RangeSlider from '../../Default/RangeSlider';
import CheckBox from '../../Default/CheckBox';

export default function Properties({ updateBlokStateSettings, thingsMoveThroughMe, friction, bounce, weight }) {
    return (
        <div className="side-bar-page-content">
            <div className="side-bar-row">
                <CheckBox
                    name="thingsMoveThroughMe"
                    checked={thingsMoveThroughMe}
                    onChange={() =>
                        updateBlokStateSettings({
                            thingsMoveThroughMe: !thingsMoveThroughMe
                        })
                    }
                >
                    Dingen kunnen door mij heen
                </CheckBox>
            </div>
            <hr />
            <div className="side-bar-row side-bar-row-title">Wrijving</div>
            <div className="side-bar-row" style={{ marginBottom: -5 }}>
                <RangeSlider
                    currentValue={friction}
                    min={0}
                    max={1}
                    step={0.01}
                    sliderStep={0.1}
                    precision={2}
                    onChange={v =>
                        updateBlokStateSettings({
                            friction: v
                        })
                    }
                    valueOnSide
                />
            </div>
            <hr />
            <div className="side-bar-row side-bar-row-title">Stuiter</div>
            <div className="side-bar-row" style={{ marginBottom: -5 }}>
                <RangeSlider
                    currentValue={bounce}
                    min={0}
                    max={1}
                    step={0.01}
                    sliderStep={0.1}
                    precision={2}
                    onChange={v =>
                        updateBlokStateSettings({
                            bounce: v
                        })
                    }
                    valueOnSide
                />
            </div>
            <hr />
            <div className="side-bar-row side-bar-row-title">Gewicht</div>
            <div className="side-bar-row">
                <RangeSlider
                    currentValue={weight}
                    min={1}
                    max={30}
                    sliderStep={0.5}
                    step={0.1}
                    precision={2}
                    onChange={v =>
                        updateBlokStateSettings({
                            weight: v
                        })
                    }
                    valueOnSide
                />
            </div>
        </div>
    );
}
